// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-tree-container .el-tree-node.is-current.is-focusable>.el-tree-node__content{background-color:#1890ff;color:#fff}.page-tree-container .el-tree-node.is-current.is-focusable>.el-tree-node__content:hover{background-color:#46a6ff}.page-tree-container .el-tree-node>.el-tree-node__content{border-radius:5px;margin-right:4px;transition:all .3s}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
